import { gql } from 'apollo-angular';

export const ResendEmailConfirmDocument = gql(/* GraphQL*/ `mutation resendEmailConfirm($email: String!)
{
  resendEmailConfirm(email: $email)
}
`);
